import React, { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes.enum";
import useUsers from "containers/user-management/useHooks";
import { EventDTO } from "utils/helpers/models/common/event.dto";
import { EventsFilterDTO } from "utils/helpers/models/users/events-filter.dto";
import DataNotFound from "components/particles/table/data-not-found";
import { useSelector } from "react-redux";
import Pagination from "components/particles/table/pagination";
import EventCard from "components/cards/EventCard";

interface Props {
    ambassadorId: any;
}

const Events: FC<Props> = ({ ambassadorId }) => {
    const navigate = useNavigate();
    const [filters, setFilters] = useState<EventsFilterDTO>(
        new EventsFilterDTO()
    );
    const { getUserEventsById } = useUsers();
    const [data, setData] = useState<EventDTO[]>([]);
    const [totalElements, setTotalElements] = useState<number>(0);
    const { isLoading } = useSelector((state: any) => state.sharedReducer);
    const timeFilterTabs = [
        // { title: "All", value: "upcoing" },
        { title: "Upcoming Events", value: "upcoming" },
        { title: "Past Events", value: "past" },
    ];

    const buildUpdatedFilters = (
        updates: Partial<EventsFilterDTO> = {},
        resetPage: boolean = false
    ) => {
        const updatedFilters = { ...filters, ...updates };
        if (resetPage) {
            updatedFilters.page = 0;
        }
        return updatedFilters;
    };

    const onPageChange = (pageInfo: { selected: number; limit: number }) => {
        const { selected: page, limit } = pageInfo;
        const updatedFilters = buildUpdatedFilters(
            { size: limit, page: page },
            false
        );
        setFilters(updatedFilters);
        getAllEvents(updatedFilters);
    };

    const getAllEvents = (filterParams: EventsFilterDTO) => {
        const queryParams: any = { ambassadorId };

        // Add pagination params
        queryParams.page = filterParams.page || 0;
        queryParams.size = filterParams.size || 8;

        // Add other filter parameters
        for (let key in filterParams) {
            if (
                key !== "ambassadorId" &&
                key !== "page" &&
                key !== "size" &&
                filterParams[key] !== undefined &&
                filterParams[key] !== null &&
                filterParams[key] !== ""
            ) {
                queryParams[key] = filterParams[key];
            }
        }

        getUserEventsById(setData, queryParams, setFilters, setTotalElements);
    };
    // working
    useEffect(() => {
        if (!filters.timeFrame) {
            setFilters((prevFilters) => ({
                ...prevFilters,
                timeFrame: "upcoming",
            }));
        }

        getAllEvents(filters);
    }, []);

    const handleFilterChange = (event: any) => {
        const { name, value } = event.target;
        let filterValue: any = value;

        if (name === "isSession") {
            filterValue =
                value === "true" ? true : value === "false" ? false : "";
        }

        let updates: Partial<EventsFilterDTO> = { [name]: filterValue };

        if (name === "timeFrame") {
            updates = { ...updates, status: undefined };
        } else if (name === "status") {
            updates = { ...updates, timeFrame: "" };
        }

        const updatedFilters = buildUpdatedFilters(updates, true);
        setFilters(updatedFilters);

        if (name !== "searchTitle") {
            getAllEvents(updatedFilters);
        }
    };

    console.log(data);

    const goToEventDetail = (id: number) => {
        navigate(`${siteRoutes.viewAmbassadorEventDetail}?id=${id}`);
    };

    return (
        <div className="">
            <div className="flex flex-wrap items-center justify-between gap-5">
                <div className="flex flex-wrap gap-3 items-center">
                    {/* Time Filter Tabs */}
                    <div className="">
                        <div className="flex gap-3">
                            {timeFilterTabs.map((tab, index) => (
                                <button
                                    key={index}
                                    className={`text-xs font-semibold pb-1 flex items-center ${filters.timeFrame === tab.value
                                        ? "text-lightBlueColor border-b border-lightBlueColor"
                                        : "text-mediumGrayText hover:text-lightBlueColor"
                                        }`}
                                >
                                    <span
                                        onClick={() =>
                                            handleFilterChange({
                                                target: { name: "timeFrame", value: tab.value },
                                            })
                                        }
                                    >
                                        {tab.title}
                                    </span>
                                </button>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="flex flex-wrap gap-4 items-center">
                    <select
                        name="isSession"
                        value={filters.isSession || undefined}
                        onChange={handleFilterChange}
                        className="px-3 border border-lightGrayBorder text-primaryText outline-none rounded-lg text-sm h-[46px] w-full sm:w-auto min-w-[140px]"
                    >
                        <option value="">Event Type</option>
                        <option value="true">Session</option>
                        <option value="false">Workshop</option>
                    </select>
                </div>
            </div>

            <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-[20px] p-6 my-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 my-6">
                    {data.map((exp: EventDTO, index: number) => (
                        <EventCard
                            key={index + 1}
                            event={exp}
                            onClick={() => goToEventDetail(exp.id)}
                        />
                    ))}
                </div>
                <div className="">
                    <DataNotFound show={!isLoading && !data.length} />
                    {totalElements > 0 && (
                        <Pagination
                            count={totalElements}
                            page={(filters.page || 0) + 1}
                            limit={filters.size || 8}
                            onPageChange={onPageChange}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Events;
